import {
  CREATE_CONTACT_FAILED,
  CREATE_CONTACT_REQ,
  CREATE_CONTACT_RESET,
  CREATE_CONTACT_SUCCESS,
  LIST_CONTACT_FAILED,
  LIST_CONTACT_REQ,
  LIST_CONTACT_SUCCESS,
} from "../Constants/contactConstant";

export const sendContactReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_CONTACT_REQ: {
      return { loading: true };
    }

    case CREATE_CONTACT_SUCCESS: {
      return { loading: false, success: payload };
    }

    case CREATE_CONTACT_FAILED: {
      return { loading: false, error: payload };
    }

    case CREATE_CONTACT_RESET: {
      return { loading: false };
    }
    default:
      return state;
  }
};

export const listContactReducer = (state = {}, { type, payload, total }) => {
  switch (type) {
    case LIST_CONTACT_REQ: {
      return { loading: true };
    }
    case LIST_CONTACT_SUCCESS: {
      return { loading: false, contactRecs: payload, total };
    }

    case LIST_CONTACT_FAILED: {
      return { laoding: false, error: payload };
    }
    default:
      return state;
  }
};
